export default __webpack_public_path__ + "static/media/menuBurger.3c8ad956.svg";